import { getFleetCategory, getFleetType, getOriginCustomer, getDestinationCustomer } from '@/api/tms.api.js'
// fleet category
export const FETCH_FLEET_CATEGORY = 'FETCH_FLEET_CATEGORY'
export const FETCH_FLEET_CATEGORY_LOADING = 'FETCH_FLEET_CATEGORY_LOADING'
export const FETCH_FLEET_CATEGORY_DONE = 'FETCH_FLEET_CATEGORY_DONE'
export const FETCH_FLEET_CATEGORY_ERROR = 'FETCH_FLEET_CATEGORY_ERROR'
// fleet type
export const FETCH_FLEET_TYPE = 'FETCH_FLEET_TYPE'
export const FETCH_FLEET_TYPE_LOADING = 'FETCH_FLEET_TYPE_LOADING'
export const FETCH_FLEET_TYPE_DONE = 'FETCH_FLEET_TYPE_DONE'
export const FETCH_FLEET_TYPE_ERROR = 'FETCH_FLEET_TYPE_ERROR'
// origin customer
export const FETCH_ORIGIN_CUSTOMER = 'FETCH_ORIGIN_CUSTOMER'
export const FETCH_ORIGIN_CUSTOMER_LOADING = 'FETCH_ORIGIN_CUSTOMER_LOADING'
export const FETCH_ORIGIN_CUSTOMER_DONE = 'FETCH_ORIGIN_CUSTOMER_DONE'
export const FETCH_ORIGIN_CUSTOMER_ERROR = 'FETCH_ORIGIN_CUSTOMER_ERROR'
// destination customer
export const FETCH_DESTINATION_CUSTOMER = 'FETCH_DESTINATION_CUSTOMER'
export const FETCH_DESTINATION_CUSTOMER_LOADING = 'FETCH_DESTINATION_CUSTOMER_LOADING'
export const FETCH_DESTINATION_CUSTOMER_DONE = 'FETCH_DESTINATION_CUSTOMER_DONE'
export const FETCH_DESTINATION_CUSTOMER_ERROR = 'FETCH_DESTINATION_CUSTOMER_ERROR'

export default {

  [FETCH_FLEET_CATEGORY] (context) {
    context.commit(FETCH_FLEET_CATEGORY_LOADING)
    return getFleetCategory()
      .then((response) => {
        context.commit(FETCH_FLEET_CATEGORY_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_FLEET_CATEGORY_ERROR, error)
      })
  },

  [FETCH_FLEET_TYPE] (context, data) {
    context.commit(FETCH_FLEET_TYPE_LOADING)
    return getFleetType(data)
      .then((response) => {
        context.commit(FETCH_FLEET_TYPE_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_FLEET_TYPE_ERROR, error)
      })
  },

  [FETCH_ORIGIN_CUSTOMER] (context) {
    context.commit(FETCH_ORIGIN_CUSTOMER_LOADING)
    return getOriginCustomer()
      .then((response) => {
        context.commit(FETCH_ORIGIN_CUSTOMER_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_ORIGIN_CUSTOMER_ERROR, error)
      })
  },

  [FETCH_DESTINATION_CUSTOMER] (context) {
    context.commit(FETCH_DESTINATION_CUSTOMER_LOADING)
    return getDestinationCustomer()
      .then((response) => {
        context.commit(FETCH_DESTINATION_CUSTOMER_DONE, response.data)
      })
      .catch((error) => {
        context.commit(FETCH_DESTINATION_CUSTOMER_ERROR, error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/tms/actions.js